/**
 * Cookie Handler Module
 * Processes the nvbkct cookie and triggers appropriate events
 */

import { getCookie } from '../utils/helpers.js';

export default function initCookieHandler() {
    // Check if the cookie exists
    const nvbkctCookie = getCookie('nvbkct');
    
    if (nvbkctCookie) {
        try {
            // Parse the cookie content (it's stored as JSON)
            const cookieData = JSON.parse(decodeURIComponent(nvbkctCookie));
            
            // Process the cookie data
            if (cookieData) {
                // Check if favorites exist in the cookie
                if (cookieData.favorites) {
                    // Trigger onload favorites updated event with cookie data
                    jQuery(document).trigger('novigran:book-catalog:favorites:updated', {
                        count: cookieData.favorites.length,
                        hasFavorites: cookieData.favorites.length
                    });
                }
                
                // Trigger a custom event that other scripts can listen for
                const event = new CustomEvent('novigran:nvbkct:cookie:processed', {
                    detail: { cookieData }
                });
                document.dispatchEvent(event);
            }
        } catch (error) {
            console.error('Error processing nvbkct cookie:', error);
        }
    }
}

